import React from "react";
import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import testimonials from '../../assets/testimonial.json'


export default class Testimonials extends React.Component {
    breakpoints = {
        320: {
            slidesPerView: 1,
            spaceBetween: 40,
        },

        1200: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
    };
    autoplay = {
        delay: 5000,
        disableOnInteraction: false,
    };
    pagination = {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
    }

    render() {
        return (
            <div>
                <div className="container">
                    <div className="section-title">
                        <h2>Testimonials</h2>
                    </div>
                </div>
                <div className="container-fluid">
                    <Swiper
                        modules={[Pagination, Autoplay]}
                        speed={600}
                        loop={true}
                        autoplay={this.autoplay}
                        slidesPerView={"auto"}
                        pagination={this.pagination}
                        breakpoints={this.breakpoints}
                    >
                        {testimonials.map((testimonial, i) => {
                            return (
                                <SwiperSlide key={i}>
                                    <div className="testimonial-item">
                                        <img src={`${testimonial.profileIcon}`} className="testimonial-img" alt="" />
                                        <h3>{testimonial.name}</h3>
                                        {/* <h4>{testimonial.qualification}</h4> */}
                                        <p>
                                            <i className="bx bxs-quote-alt-left quote-icon-left"></i>
                                            {testimonial.quote}
                                            <i className="bx bxs-quote-alt-right quote-icon-right"></i>
                                        </p>
                                    </div>
                                </SwiperSlide>
                            )
                        })}
                        <div className="swiper-pagination"></div>
                    </Swiper>
                </div>
            </div>
        );
    }
}
